import { render, staticRenderFns } from "./TransferOutItem.vue?vue&type=template&id=6470d4d8&scoped=true"
import script from "./TransferOutItem.vue?vue&type=script&lang=js"
export * from "./TransferOutItem.vue?vue&type=script&lang=js"
import style0 from "./TransferOutItem.vue?vue&type=style&index=0&id=6470d4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6470d4d8",
  null
  
)

export default component.exports